// react
import { useState, useEffect } from 'react'

// redux
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  showAppModal
} from '~/redux/actions/app'
import {
  voteComment,
  unvoteComment,
  VOTE_COMMENT,
  UNVOTE_COMMENT
} from '~/redux/actions/comment'

// views
import Icon from '@ant-design/icons'
import IconLink from '~/components/app/IconLink'
import FlashIcon from '~/components/app/FlashIcon'

import _ from 'lodash'

const CommentVote = props => {
  // hooks
  const [state, setState] = useState({
    votes: props.votes,
    loading: false
  })

  // props
  const voteText = state.votes || '电一下'
  const voted = _.includes(props.flags.voted, props.id)

  // handles
  const handleClick = async () => {
    if (!props.token) {
      props.showAppModal('PhoneSigninModal')
      return
    }

    setState(prev => ({ ...prev, loading: true }))
    try {
      if (voted) {
        await props.unvoteComment(props.token, props.id)
      } else {
        await props.voteComment(props.token, props.id)
      }
    } finally {
      setState(prev => ({ ...prev, loading: false }))
    }
  }

  const handleVoteChange = () => {
    const { name, data } = props.event

    let votes = state.votes
    if (name === VOTE_COMMENT && data === props.id) {
      votes += 1
    } else if (name === UNVOTE_COMMENT && data === props.id) {
      votes -= 1
    }

    if (votes < 0) {
      votes = 0
    }

    setState(prev => ({ ...prev, votes }))
  }

  // events
  useEffect(() => handleVoteChange(), [props.event])

  return (
    <IconLink
      icon={<Icon component={FlashIcon} style={{ verticalAlign: 'middle' }} />}
      className={`${voted ? 'text-primary' : 'text-secondary'} text-sm`}
      text={voteText}
      onClick={handleClick}
      loading={state.loading}
    />
  )
}

const mapStateToProps = (state) => ({
  event: state.app.event,
  token: state.user.token,
  flags: state.comment.commentFlags
})

const mapDispatchToProps = dispatch => bindActionCreators({
  voteComment,
  unvoteComment,
  showAppModal
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CommentVote)
